<template>
  <div class="tree" ref="main">
    <div class="label" v-if="label" v-html="label" />

    <div class="filter">
      <input
        type="text"
        ref="filter"

        :value="filter"
        v-debounce.trim
        @debouncedInput="filterApply( $event )"
        @keydown="$event.key == 'Enter' && filterApply()"
      />
      <div
        class="apply"
        @click="filterApply()"
      />
      <div
        class="clear"
        @click="filterApply( '' )"
      />
    </div>

    <TreeNode
      class="branches"
      key="root"

      :data="data"

      :root="true"
      :selectedId="selectedId_"
      :CSSnames="CSSnames"

      @selected="select( $event )"
      @fetch="$emit( 'fetch', $event )"
    />
  </div>
</template>

<script>
import TreeNode from "@/components/tree/TreeNode";

export default {
  name: "tree",

  components: {
    TreeNode
  },

  props: {
    label: {
      type: String,
      default: null
    },

    data: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          children: []
        };
      }
    },

    selectedId: {
      type: String,
      default: null
    },

    filter: {
      type: String,
      default: ""
    },

    CSSnames: {
      type: Function,
      default: i => i.marked ? "marked" : ""
    }
  },
  data() {
    return {
      selectedId_: null,
    };
  },
  mounted() {
    const tree = this.$refs.main ? this.$refs.main : null;
    if ( tree ) {
      const h = e => {
        let el = e.target;

        if ( e.type == "dblclick" ) {
/*
          for ( let i = 0; el && i < 3; i++ ) {
            if ( el.classList.contains( "name" ) ) {
              el = el.parentNode.querySelector( ".opener" );
              break;
            }
            el = el.parentNode;
          }
          if ( !el || !el.classList.contains( "opener" ) ) el = e.target;
*/

          for ( let i = 0; el && i < 5; i++ ) {
            if ( el.classList.contains( "node" ) ) {
              if ( el && el.__vue__ && el.__vue__.data && el.__vue__.data ) this.$emit( "accept", el.__vue__.data );

              break;
            }

            el = el.parentNode;
          }

          return;
        }

        for ( let i = 0; el && i < 3; i++ ) {
          if ( el.classList.contains( "opener" ) ) {
            while ( el && !el.classList.contains( "node" ) ) el = el.parentNode;
            if ( el ) {
              const openclose = el.__vue__ && el.__vue__.openclose ? el.__vue__.openclose : () => {};
              openclose();
            }

            break;
          }

          el = el.parentNode;
        }
      };

      tree.addEventListener( "click", h );
      tree.addEventListener( "dblclick", h );
    }

    if ( this.$refs.filter ) this.$refs.filter.focus();
  },
  methods: {
    select( node ) {
      const id = node && node.id ? node.id : null;
      if ( this.selectedId_ !== id ) {
        this.selectedId_ = id;
        this.$emit( "selected", node );
      }
    },

    filterApply( value ) {
      if ( !this.$refs.filter ) return;

      const vi = this.$refs.filter.value;
      let v = vi;
      if ( value !== undefined ) v = value;

      if ( this.filter !== v ) {
        if ( v !== vi ) this.$refs.filter.value = v;
        this.$emit( "filter", v );
      }
    }
  },

  watch: {
    selectedId: {
      immediate: true,
      handler( v ) {
        if ( this.selectedId_ !== v ) this.selectedId_ = v;
      }
    }
  }
}
</script>

<style scoped>
  .tree {
    color: #212121;
  }

  .label {
    font-size: 1.2em;
    margin-bottom: 1em;
  }

  .filter {
    margin-bottom: 1em;
    position: relative;
    /*box-shadow: inset 1px 1px 3px #000000;*/
    padding: 0.1em 3.4em 0.1em 0.3em;
    border-radius: 0.2em;
    border: solid 1px #C4C4C4;
    overflow: hidden;
  }

  .filter input {
    width: 100%;
    border: none;
    border-radius: 0.2em;
    padding: 0;
    outline: none;
    background-color: transparent;
    height: 2em;
  }

  .filter .apply {
    position: absolute;
    border-radius: 0 0.2em 0.2em 0;
    background-color: #0C97E7;
    top: 0;
    bottom: 0;
    right: 0;
    width: 2em;
    cursor: pointer;
  }

  .filter .apply:after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    width: 1px;
    left: 0;
    /*box-shadow: -1px 0 3px #000000;*/
  }

  .filter .apply:before {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20viewBox%3D%220%200%2022%2022%22%20fill%3D%22%23FFFFFF%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%20%3Cpath%20d%3D%22M14.8647%2013.4093H14.0953L13.8279%2013.1438C14.7727%2012.042%2015.3473%2010.6137%2015.3473%209.0487C15.3473%205.56991%2012.5274%202.75005%209.04864%202.75005C5.56985%202.75005%202.75%205.56991%202.75%209.0487C2.75%2012.5275%205.56985%2015.3473%209.04864%2015.3473C10.6136%2015.3473%2012.041%2014.7737%2013.1428%2013.8299L13.4102%2014.0954V14.8628L18.2534%2019.6992L19.6982%2018.2544L14.8647%2013.4093ZM9.04858%2013.4093C6.63959%2013.4093%204.68798%2011.4577%204.68798%209.0487C4.68798%206.64068%206.63959%204.6881%209.04858%204.6881C11.4566%204.6881%2013.4092%206.64068%2013.4092%209.0487C13.4092%2011.4577%2011.4566%2013.4093%209.04858%2013.4093Z%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 1.3em auto;
    transition: transform 0.2s ease-in-out;
  }
  .filter .apply:hover:before {
    transform: scale( 1.2 );
  }

  .filter .clear {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 2.2em;
    width: 1em;
    cursor: pointer;
    opacity: 0.8;
    transition: opacity 0.2s ease-in-out;
  }
  .filter .clear:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0.8em;
    line-height: 0;
    border-radius: 100%;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20version%3D%221.1%22%20viewBox%3D%220%200%2022%2022%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%20%20%20%3Cpath%20d%3D%22m11%200c6.083%200%2011%204.917%2011%2011s-4.917%2011-11%2011-11-4.917-11-11%204.917-11%2011-11m3.949%205.5-3.949%203.949-3.949-3.949-1.551%201.551%203.949%203.949-3.949%203.949%201.551%201.551%203.949-3.949%203.949%203.949%201.551-1.551-3.949-3.949%203.949-3.949z%22%20%2F%3E%0D%0A%3C%2Fsvg%3E);
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 0.8em auto;
  }
  .filter .clear:hover {
    opacity: 1;
  }

  .filter .apply:active:before,
  .filter .clear:active:before {
    top: 1px;
    left: 1px;
  }

  .tree {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .filter {
    flex-grow: 0;
    flex-shrink: 0;
  }
  .branches {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
  }
</style>